import { APISERVICE, readLocalStorage, writeLocalStorage } from "@api/RestClient";
import { resolveStoreId } from "@storeData/store";
import {
    createFetchError,
    createNotFoundError,
    normalizeResourceError,
    RESOURCE_FETCH_FAILED,
    RESOURCE_NOT_FOUND,
    ResourceError,
    withRetry
} from "@util/apiError";

export const ORDER_NOT_FOUND = RESOURCE_NOT_FOUND;
export const ORDER_FETCH_FAILED = RESOURCE_FETCH_FAILED;

export type OrderFetchError = ResourceError;

const fetchResource = async <T>(
    url: string,
    selectData: (response: any) => T,
    headers: any = {}
): Promise<T> => {
    try {
        return await withRetry(async () => {
            const response = await APISERVICE.GET(url, headers);
            const data = selectData(response);
            if (!data) throw createNotFoundError(response?.status);
            return data;
        });
    } catch (error) {
        throw normalizeResourceError(error);
    }
};

export const getOrderByOrderId = async (id, storeId, tenantId = null, storeName = '', headers: any = {}) => {
    let resolvedStoreId;
    try {
        resolvedStoreId = await resolveStoreId(tenantId, storeId, storeName);
    } catch (error) {
        console.error(`Unable to resolve storeId for order ${id}`, error);
        throw createFetchError(error);
    }

    if (!readLocalStorage("User_Data")) {
        writeLocalStorage("User_Data", `user_${tenantId}_${resolvedStoreId}`);
    }

    return fetchResource(
        `${process.env.NEXT_PUBLIC_ORDERS}/fetch/${id}?storeId=${resolvedStoreId}`,
        (response) => response?.data,
        headers
    );
};

export const getOrderByTenantIdAndGuestId = (guestid, tenantid) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_ORDERS}/tenant/guest?id=${guestid}&tenantId=${tenantid}`)  //get order history
            .then(async (ordersData) => {
                if (ordersData.status == 200) {
                    const orders = ordersData.data;
                    if (orders) {
                        res(orders)
                    } else {
                        rej({ error: 'Order unavailable' });
                    }
                } else if (ordersData.status == 401) {
                    rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_ORDERS}/tenant/guest?id=${guestid}&tenantId=${tenantid}`, status: ordersData.status });
                }
            }).catch(function (error) {
                rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_ORDERS}/tenant/guest?id=${guestid}&tenantId=${tenantid}`, status: error });
                console.error("error", error);
            });
    })
};

export const getMembershipOrderByOrderId = (id, headers: any = {}) =>
    fetchResource(
        `${process.env.NEXT_PUBLIC_CUSTOMER}/guestMembershipTransaction?id=${id}`,
        (response) => response?.data?.data,
        headers
    );

// https://localhost:8083/pcs-guest/v1/customer/guestPackageDetails?id=1
export const getPackageOrderByOrderId = (id, headers: any = {}) =>
    fetchResource(
        `${process.env.NEXT_PUBLIC_CUSTOMER}/guestPackageDetails?id=${id}`,
        (response) => response?.data?.data,
        headers
    );

export const getGiftCardDetailsById = (id, headers: any = {}) =>
    fetchResource(
        `${process.env.NEXT_PUBLIC_CUSTOMER}/guestGiftCardDetails?id=${id}`,
        (response) => response?.data?.data,
        headers
    );

export const getAdvanceBalanceDetailsById = (id, headers: any = {}) =>
    fetchResource(
        `${process.env.NEXT_PUBLIC_PCS_TXN}/advBalTxnById?txnId=${id}`,
        (response) => response?.data,
        headers
    );
